<template>
  <Container class="w-full">
    <div
      class="my-12 flex w-full flex-col items-center justify-between rounded-3xl px-4 py-6 text-white lg:my-24 lg:flex-row lg:p-12"
      :class="`bg-${backgroundGradient}`">
      <div class="flex flex-col items-center space-y-4 lg:flex-row lg:space-x-8 lg:space-y-0">
        <NuxtImg
          v-if="image"
          :src="image"
          :alt="title || ''"
          class="h-28 w-28 rounded-xl object-cover"
          sizes="xs:112px sm:112px md:112px lg:112px xl:112px xxl:112px"
          loading="lazy" />
        <h3 class="text-center text-3xl font-medium lg:text-left">
          {{ title }}
        </h3>
      </div>

      <div class="mt-6 grid grid-cols-2 gap-2 md:gap-4 lg:mt-0">
        <ButtonStore
          v-for="storeLink in storeLinks"
          :key="storeLink.id"
          :store-id="storeLink.id"
          :url="storeLink.url"
          class="h-12 lg:h-15"
          @click="track(storeLink)" />
      </div>
    </div>
  </Container>
</template>

<script setup lang="ts">
  import { useNuxtApp } from '#imports'

  import type { StoreId } from '~/constants'

  type StoreLink = {
    id: StoreId
    name: string
    url: string
  }

  type BlogGameCta = {
    backgroundGradient: string
    title: string
    image: string
    storeLinks: StoreLink[]
  }

  const props = defineProps<BlogGameCta>()
  const { $event } = useNuxtApp()

  function track(storeLink: StoreLink) {
    $event('Game CTA', {
      props: {
        'Game Title': props.title,
        'Store Name': storeLink.name,
        'Store URL': storeLink.url
      }
    })
  }
</script>
